import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import rpc from '@tencent/vft-rpc-tool';
import { checkRes, RequestLogicError } from '@tencent/Coa';
import { lock } from '@/util/decorator';
import retry from '@/util/retry';
import { request } from './util';
var baseUrl = 'https://vip.video.qq.com/fcgi-bin/comm_cgi';
var fetchNum = window.setting.红包份数 || 3;
var actId = window.setting.魔方配置.红包活动ID || '106910'; // 正式 110680 测试106910

var LaiseeService = (_class = /*#__PURE__*/function () {
  function LaiseeService() {
    _classCallCheck(this, LaiseeService);
  }

  _createClass(LaiseeService, null, [{
    key: "writeLaiseeQual",
    value:
    /**
     * 写红包资格
     */
    function writeLaiseeQual() {
      return rpc('trpc.vip_red_group.anniversary_red_qualification.AnniversaryRedQualification', 'RedQualificationSend', {
        act_id: actId
      }, {
        withCredentials: true
      });
    }
    /**
     * 查红包资格列表
     */

  }, {
    key: "getLaiseeQualList",
    value: function getLaiseeQualList() {
      return retry(function () {
        return rpc('trpc.vip_red_group.anniversary_red_qualification.AnniversaryRedQualification', 'GetUserRedQualifications', null, {
          withCredentials: true
        });
      }, 2);
    }
    /**
     * 创建红包接口
     * @param {String} orderId 订单id
     */

  }, {
    key: "create",
    value: function create(_ref) {
      var head = _ref.head,
          nick = _ref.nick,
          orderId = _ref.orderId,
          type = _ref.type;
      var options = {
        name: 'spp_vipred_route_write',
        cmd: 1,
        type: type,
        head: head,
        nick: nick,
        order_id: orderId,
        act_id: actId
      };
      return request({
        retry: 1
      })(baseUrl, options);
    }
    /**
     * 红包资格接口
     */
    // @lock
    // static getLockStatus() {
    //   const options = {
    //     name: 'spp_vipred_get_openrecord',
    //     cmd: 3,
    //   };
    //   return request()(baseUrl, options);
    // }

    /**
     * 获取最近订单列表
     */

  }, {
    key: "getOrderList",
    value: function () {
      var _getOrderList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var step, options, res, orderList, _nextPage$order_list, nextPage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                step = 10;
                options = {
                  name: 'spp_vipred_route_read',
                  cmd: 4,
                  offset: 0,
                  page_id: actId,
                  // status: 1,
                  count: step
                };
                _context.next = 4;
                return request({
                  retry: 1
                })(baseUrl, options);

              case 4:
                res = _context.sent;
                // eslint-disable-next-line camelcase
                orderList = (res === null || res === void 0 ? void 0 : res.order_list) || []; // 临时逻辑，只多拉取一次下一页

                if (res.isFinish) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return request({
                  retry: 1
                })(baseUrl, _objectSpread(_objectSpread({}, options), {}, {
                  offset: step
                }));

              case 9:
                nextPage = _context.sent;

                // eslint-disable-next-line camelcase
                if ((nextPage === null || nextPage === void 0 ? void 0 : (_nextPage$order_list = nextPage.order_list) === null || _nextPage$order_list === void 0 ? void 0 : _nextPage$order_list.length) > 0) {
                  orderList = [].concat(_toConsumableArray(orderList), _toConsumableArray(nextPage.order_list));
                }

              case 11:
                return _context.abrupt("return", orderList);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getOrderList() {
        return _getOrderList.apply(this, arguments);
      }

      return getOrderList;
    }()
    /**
     * 查询红包详情接口
     * 获取红包发送者信息/红包剩余
     * @param {String} laiseeId 红包id
     */

  }, {
    key: "getInfo",
    value: function getInfo(laiseeId) {
      var options = {
        name: 'spp_vipred_route_read',
        cmd: 1,
        laisee_id: laiseeId
      };
      return request({
        retry: 1
      })(baseUrl, options);
    }
    /**
     * 领取红包接口
     * @param {String} laiseeId 红包id
     */

  }, {
    key: "fetchLaisee",
    value: function fetchLaisee(_ref2) {
      var laiseeId = _ref2.laiseeId,
          head = _ref2.head,
          nick = _ref2.nick;
      var options = {
        name: 'spp_vipred_route_write',
        cmd: 2,
        page_id: actId,
        laisee_id: laiseeId,
        head: head,
        nick: nick
      };
      return request({
        retry: 1,
        timeout: 3000
      })(baseUrl, options);
    }
    /**
     * 拉取领取列表接口
     * 获取红包领取人列表
     * @param {String} laiseeId 红包id
     */

  }, {
    key: "getfetcherList",
    value: function getfetcherList(laiseeId) {
      var options = {
        name: 'spp_vipred_route_read',
        cmd: 3,
        count: fetchNum,
        laisee_id: laiseeId
      };
      return request({
        checkRes: checkRes(function (res) {
          // 后台接口历史逻辑，-1代表没有领取
          if (res.result && ![0, -1].includes(res.result.code)) {
            var code = res.ret || res.result && res.result.code;
            var msg = res.msg || res.result && res.result.msg;
            throw new RequestLogicError(msg, code, res);
          }

          return res;
        }),
        retry: 2
      })(baseUrl, options);
    }
  }]);

  return LaiseeService;
}(), (_applyDecoratedDescriptor(_class, "writeLaiseeQual", [lock], Object.getOwnPropertyDescriptor(_class, "writeLaiseeQual"), _class), _applyDecoratedDescriptor(_class, "getLaiseeQualList", [lock], Object.getOwnPropertyDescriptor(_class, "getLaiseeQualList"), _class), _applyDecoratedDescriptor(_class, "create", [lock], Object.getOwnPropertyDescriptor(_class, "create"), _class), _applyDecoratedDescriptor(_class, "getOrderList", [lock], Object.getOwnPropertyDescriptor(_class, "getOrderList"), _class), _applyDecoratedDescriptor(_class, "getInfo", [lock], Object.getOwnPropertyDescriptor(_class, "getInfo"), _class), _applyDecoratedDescriptor(_class, "fetchLaisee", [lock], Object.getOwnPropertyDescriptor(_class, "fetchLaisee"), _class)), _class);
export default LaiseeService;